import { AnchorButton } from "@blueprintjs/core";
import { IconDefinition } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HoverCard, Tooltip } from "@mantine/core";

export const FooterIcon: React.FC<{
  icon: IconDefinition;
  highlight?: boolean;
  path?: string;
  popover?: JSX.Element;
  text?: string;
  style?: React.CSSProperties;
}> = ({ icon, popover, highlight = false, path, text, style }) => {
  const button = (
    <AnchorButton
      small
      href={path}
      minimal={!highlight}
      style={{
        color: highlight ? undefined : "var(--global-blue-gray)",
        height: "30px",
        ...style,
      }}
      intent={highlight ? "success" : undefined}
    >
      <FontAwesomeIcon icon={icon} />
    </AnchorButton>
  );
  if (popover) {
    return (
      <HoverCard withArrow withinPortal position="top-start">
        <HoverCard.Target>
          <div>{button}</div>
        </HoverCard.Target>
        <HoverCard.Dropdown>{popover}</HoverCard.Dropdown>
      </HoverCard>
    );
  } else if (text) {
    return (
      <Tooltip withArrow withinPortal label={text}>
        <div>{button}</div>
      </Tooltip>
    );
  }
  return button;
};
